/**
 * Chips de texto libre con sugerencias: Enter o coma agrega, × saca. Nació en el form de
 * packs de Partnerships (13/10/2026) y pasó a ui/ con el segundo consumidor (el alta de
 * perfiles PML del Brain, 19/10/2026). Para elegir de una lista cerrada va MultiSelectPopover.
 */
import { useState } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function TagInput({ value, onChange, suggestions = [], placeholder, listId, className }: {
  value: string[];
  onChange: (next: string[]) => void;
  suggestions?: string[];
  placeholder?: string;
  listId: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState('');
  const add = (raw: string) => {
    const v = raw.replace(/\s+/g, ' ').trim();
    if (!v) return;
    if (!value.some(x => x.toLowerCase() === v.toLowerCase())) onChange([...value, v]);
    setDraft('');
  };
  return (
    <div className={`flex flex-wrap gap-1.5 p-2 border rounded-md min-h-10 items-center ${className ?? ''}`}>
      {value.map(v => (
        <span key={v} className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-foreground text-background">
          {v}
          <button type="button" onClick={() => onChange(value.filter(x => x !== v))} aria-label={t('common.remove_item', { item: v })} className="hover:opacity-70"><X className="h-3 w-3" /></button>
        </span>
      ))}
      <input
        list={suggestions.length ? listId : undefined}
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(draft); } }}
        onBlur={() => add(draft)}
        placeholder={placeholder}
        className="flex-1 min-w-32 bg-transparent text-xs outline-hidden"
      />
      {suggestions.length > 0 && <datalist id={listId}>{suggestions.map(s => <option key={s} value={s} />)}</datalist>}
    </div>
  );
}
